import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaHome, FaUsers, FaMoneyBillWave, FaMoneyBillAlt,
  FaBars, FaSignOutAlt, FaChartLine
} from 'react-icons/fa';
import { useAuth } from '../../contexts/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const { user, logout, hasPermission } = useAuth();
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: FaHome, label: 'Dashboard', permission: null },
    { path: '/socios', icon: FaUsers, label: 'Sócios', permission: 'pode_consultar' },
    { path: '/receitas', icon: FaMoneyBillWave, label: 'Receitas', permission: 'pode_consultar' },
    { path: '/despesas', icon: FaMoneyBillAlt, label: 'Despesas', permission: 'pode_consultar' },
    { path: '/balancete', icon: FaChartLine, label: 'Balancete', permission: 'pode_consultar' },
    // { path: '/eventos', icon: FaCalendarAlt, label: 'Eventos', permission: 'pode_consultar' },
    // { path: '/mensalidades', icon: FaCreditCard, label: 'Mensalidades', permission: 'pode_consultar' },
    // { path: '/usuarios', icon: FaUserCog, label: 'Usuários', permission: 'pode_alterar' },
  ];

  const visibleMenuItems = menuItems.filter(item => 
    !item.permission || hasPermission(item.permission)
  );

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    } else {
      setSidebarOpen(true);
    }
  }, [isMobile]);

  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  const handleToggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="layout">
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-header">
          <div className="logo">
            <div className="logo-icon">P</div>
            {sidebarOpen && <span>Palmeiras</span>}
          </div>
        </div>

        <nav className="sidebar-nav">
          {visibleMenuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-item ${isActive ? 'active' : ''}`}
                onClick={closeSidebar}
              >
                <Icon className="nav-icon" />
                {sidebarOpen && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button onClick={logout} className="nav-item logout-btn">
            <FaSignOutAlt className="nav-icon" />
            {sidebarOpen && <span>Sair</span>}
          </button>
        </div>
      </aside>

      <div className={`sidebar-overlay ${sidebarOpen && isMobile ? 'visible' : ''}`} onClick={closeSidebar} />

      <div className="main-content">
        <header className="top-bar">
          <button 
            className="menu-toggle"
            onClick={handleToggleSidebar}
          >
            <FaBars />
          </button>

          <div className="user-info">
            <span className="user-name">
              {user?.nome} {user?.sobrenome}
            </span>
            <div className="user-avatar">
              {user?.nome?.charAt(0).toUpperCase()}
            </div>
          </div>
        </header>

        <main className="content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
